(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5467],{

/***/ 23257:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var apiToAlert = function apiToAlert(apiError) {
  return {
    analyticsLabel: apiError.response || "API returned ".concat(JSON.stringify(apiError)),
    children: apiError.explanation || 'Oh no!',
    heading: apiError.response || 'Something went wrong',
    level: apiError.level || 'danger'
  };
};
var _default = exports["default"] = apiToAlert;
module.exports = exports.default;

/***/ }),

/***/ 55105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const lodash_1 = __importDefault(__webpack_require__(96486));
const assert_1 = __importDefault(__webpack_require__(27596));
const constants_1 = __webpack_require__(13294);
const LISTED_PRODUCT_TYPE_PATHS = {
    combined: 'hospital-extras-bundle',
    extras: 'extras-cover',
    hospital: 'hospital-cover',
    package: 'hospital-extras-packages',
};
function getProductUrl(args) {
    const { errorUrl, productId, rawUrl } = args || { errorUrl: undefined, productId: undefined, rawUrl: undefined };
    (0, assert_1.default)(lodash_1.default.isString(rawUrl), 'rawUrl must be a string');
    (0, assert_1.default)(lodash_1.default.isString(productId), 'productId must be a string');
    (0, assert_1.default)(lodash_1.default.isString(errorUrl), 'errorUrl must be a string');
    const type = lodash_1.default.findKey(constants_1.PRODUCTS_BY_TYPE, (products) => lodash_1.default.includes(products, productId));
    const parentProductId = lodash_1.default.findKey(constants_1.PRODUCTS_BY_PARENT, (products) => lodash_1.default.includes(products, productId));
    if (lodash_1.default.isUndefined(type) || lodash_1.default.isUndefined(productId)) {
        return errorUrl;
    }
    const productUrl = (0, lodash_1.default)(rawUrl)
        .replace(':type', LISTED_PRODUCT_TYPE_PATHS[type])
        .replace(':id', parentProductId || lodash_1.default.replace(productId, /(\b-excess-)[0-9]*/, ''));
    return productUrl;
}
module.exports = {
    getProductUrl,
};


/***/ }),

/***/ 12662:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pregnancy",
      function () {
        return __webpack_require__(78332);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/constants/lib/src/index.js
var src = __webpack_require__(13294);
;// CONCATENATED MODULE: ./src/client/pages/pregnancy/constants.ts
var accordionId = "pregnancy-accordion";
var outOfPocketSectionId = "out-of-pocket";
var mobileThreshold = "60rem";
var outOfPocketSectionIndex = 2;


// EXTERNAL MODULE: ./src/client/utils/ui.ts
var ui = __webpack_require__(85500);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ahm_constants_ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/client/actions/accordion/index.ts
var accordion = __webpack_require__(75586);
// EXTERNAL MODULE: ./src/client/components/sections/accordion-section/index.tsx + 4 modules
var accordion_section = __webpack_require__(64323);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
;// CONCATENATED MODULE: ./src/client/pages/pregnancy/images/baby.svg
/* harmony default export */ var baby = ({"src":"/_next/static/media/baby.cbe0b1d6.svg","height":213,"width":170});
;// CONCATENATED MODULE: ./src/client/pages/pregnancy/images/doctor.svg
/* harmony default export */ var doctor = ({"src":"/_next/static/media/doctor.a52fefba.svg","height":178,"width":128});
;// CONCATENATED MODULE: ./src/client/pages/pregnancy/images/hospital.svg
/* harmony default export */ var hospital = ({"src":"/_next/static/media/hospital.858dcec6.svg","height":213,"width":171});
;// CONCATENATED MODULE: ./src/client/pages/pregnancy/images/pregnancy-test.svg
/* harmony default export */ var pregnancy_test = ({"src":"/_next/static/media/pregnancy-test.2fd1dc07.svg","height":361,"width":1154});
;// CONCATENATED MODULE: ./src/client/pages/pregnancy/data.tsx







// @ts-expect-error - Automatic, Please fix when editing this file
var data = function(onClickOutOfPocket) {
    return {
        headerSection: {
            advantages: {
                tiles: [
                    {
                        image: {
                            alt: "Hospital",
                            src: hospital.src
                        },
                        summary: "Choose the private hospital where you give birth in a location that suits you and your obstetrician.",
                        title: "Location, location, location"
                    },
                    {
                        image: {
                            alt: "Doctor",
                            src: doctor.src
                        },
                        summary: "Choose your obstetrician to care for you through pregnancy and birth.",
                        title: "Choice of doctor"
                    },
                    {
                        image: {
                            alt: "Baby",
                            src: baby.src
                        },
                        summary: "You could get a private room for just you and your baby (subject to availability).",
                        title: "More … privacy"
                    }, 
                ],
                title: "The advantages of going private"
            },
            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Thinking about having a baby in a private hospital? We have hospital cover that pays towards services you receive in hospital during pregnancy and birth and helps you to enjoy the advantages of going private. To ensure you can use your health insurance for the birth of your baby, you just need to make sure you serve the",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                        children: "12-month"
                    }),
                    " Waiting Period before your due date. It’s important to also be aware of any potential",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                        onClick: onClickOutOfPocket,
                        children: "out-of-pocket costs"
                    }),
                    "."
                ]
            }),
            image: {
                alt: "Pregnancy test",
                src: pregnancy_test.src
            },
            title: "Pregnancy and birth"
        },
        productSection: {
            subtitle: "Hospital cover for pregnancy and birth and a few options for extras cover.",
            title: "Some covers with benefits towards pregnancy and birth"
        }
    };
};
/* harmony default export */ var pregnancy_data = (data);

// EXTERNAL MODULE: ./src/utils/head.tsx
var head = __webpack_require__(40985);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/client/components/sections/features-section/index.tsx + 3 modules
var features_section = __webpack_require__(84244);
// EXTERNAL MODULE: ./src/client/pages/pregnancy/components/header-description-block/styles.module.sass
var styles_module = __webpack_require__(73875);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/pages/pregnancy/components/header-description-block/index.tsx





var HeaderDescriptionBlock = function(param) {
    var description = param.description, _image = param.image, alt = _image.alt, src = _image.src, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* AxisSwitcher */.e$, {
        reverseColumnPresentationOrder: true,
        limit: 2,
        space: "0",
        threshold: mobileThreshold,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
                padding: "0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).headerImageWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                        className: (styles_module_default()).headerImage,
                        alt: alt,
                        src: src
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* GridBox */.zc, {
                minWidth: "70%",
                padding: "0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H1, {
                        children: title
                    }),
                    description
                ]
            })
        ]
    });
};
/* harmony default export */ var header_description_block = (HeaderDescriptionBlock);

// EXTERNAL MODULE: ./src/client/pages/pregnancy/styles.module.sass
var pregnancy_styles_module = __webpack_require__(90569);
var pregnancy_styles_module_default = /*#__PURE__*/__webpack_require__.n(pregnancy_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/pregnancy/components/header-section/index.tsx








var HeaderSection = function(_param) /*#__PURE__*/ {
    var advantages = _param.data.advantages, headerDescriptionProps = (0,_object_without_properties/* default */.Z)(_param.data, [
        "advantages"
    ]);
    return (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
        hideBorderTop: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
            padding: "1rem",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (pregnancy_styles_module_default()).horizontalSpacingWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                        variant: [
                            "marginTopSpacer2",
                            "marginBottomSpacer6"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_description_block, (0,_object_spread/* default */.Z)({}, headerDescriptionProps))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(features_section/* default */.Z, (0,_object_spread/* default */.Z)({}, advantages))
                ]
            })
        })
    });
};
/* harmony default export */ var header_section = (HeaderSection);

;// CONCATENATED MODULE: ./src/client/pages/pregnancy/content/items.tsx





var contactUsLink = /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
    to: ahm_constants/* default.URLS.SALES.CONTACT_US */.Z.URLS.SALES.CONTACT_US,
    children: "contact us"
});
var items = [
    {
        analyticsLabel: "waiting-period",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "It’s not just us, most insurers have a 12-month waiting period on private hospital cover for pregnancy and birth. If you’re thinking about getting private cover, or upgrading your cover to include pregnancy and birth services, you’ll need to have the appropriate cover in place ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                    children: "before"
                }),
                " you become pregnant to ensure the waiting period has been served. If you’re admitted during your pregnancy and have not served the 12 month waiting period at the time you’re admitted, you may not be entitled to any benefits.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "If you’re joining ahm from another Australian health fund at the same level of cover (e.g. Gold product tier) or lower but with pregnancy and birth included, you don’t need to re-serve waiting periods you’ve already served."
            ]
        }),
        title: "More about the 12-month waiting period"
    },
    {
        analyticsLabel: "included",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "We have hospital cover that pays benefits towards services and treatment provided in hospital during pregnancy, childbirth and following delivery.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "This includes accommodation as a private patient in a private or public hospital (shared room only in a public hospital) and any fees for the labour ward, theatre or intensive care.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "It also includes benefits towards inpatient medical services. Medicare pays 75% of the Medicare Benefits Schedule (MBS) fee for your obstetrician, anaesthetist and other doctors, as well as any diagnostics (e.g. x-rays or lab tests) while you’re admitted to hospital, while ahm pays the remaining 25% of the MBS fee. It’s important to understand that some doctors and providers charge above the MBS fee and when this occurs you’ll have to pay the difference—this is known as the ‘gap’."
            ]
        }),
        title: "What’s included in pregnancy and birth?"
    },
    {
        analyticsLabel: "not-included",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "If an excess applies to your cover, you’ll need to pay this, any personal expenses like additional meals for your partner or any other expenses not covered by our agreement with the hospital, as well as any pharmaceuticals (including drugs issued on discharge) not covered by our agreement with the hospital.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Some doctors and providers charge fees for inpatient medical services that are higher than the Medicare Benefits Schedule (MBS) fee. When this happens, you’ll have to pay the difference—this is known as the ‘gap’. You may be able to reduce the gap by choosing doctors who agree to participate in ahm’s GapCover scheme for each claim as part of your treatment.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "For more information on GapCover refer to",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                    to: ahm_constants/* default.URLS.HELP.WHAT_IS_GAP_COVER */.Z.URLS.HELP.WHAT_IS_GAP_COVER,
                    children: "What is GapCover?"
                }),
                " or",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                    to: ahm_constants/* default.URLS.FILES.MEMBER_GUIDE */.Z.URLS.FILES.MEMBER_GUIDE,
                    children: "Member Guide"
                }),
                ".",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Also, private health insurers are not permitted to pay benefits towards outpatient services (when you or your newborn are not admitted to hospital). While you may be eligible to claim a Medicare rebate, you’ll have out-of-pockets for the many outpatient appointments you’re likely to have during pregnancy such as scans, tests, and visits with your obstetrician/GP. Also, healthy newborns are generally not admitted to hospital after the birth so there may also be outpatient appointments for your baby too, for example with a paediatrician.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "This can be a little confusing, so ",
                contactUsLink,
                " for more information."
            ]
        }),
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            id: outOfPocketSectionId,
            children: "What’s not included in pregnancy and birth? About out-of-pocket costs"
        })
    },
    {
        analyticsLabel: "informed-consent",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Informed Financial Consent is your right to know how much your treatment costs before you go to hospital. You can ask your doctor or obstetrician to provide a breakdown of the out-of-pocket costs you are likely to incur during your hospital admission. For more, read our guide to",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                    to: ahm_constants/* default.URLS.HELP.INFORMED_FINANCIAL_CONSENT */.Z.URLS.HELP.INFORMED_FINANCIAL_CONSENT,
                    children: " informed financial consent"
                }),
                "."
            ]
        }),
        title: "Ask for Informed Financial Consent"
    },
    {
        analyticsLabel: "day-one",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Your baby isn’t automatically included on your cover as soon as they are born. You need to ",
                contactUsLink,
                " as soon as possible to add your baby to your cover.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "If you’re on a single cover and want to add your baby, you’ll need to change your cover type to either a family or single parent family cover within two months of the baby’s birth.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "This change to your cover will take effect from the date of birth, and any difference in premiums will be payable from that date. This will ensure the baby only has to serve any Waiting Periods not already served by the Principal Member.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "If you already hold a family or single parent family cover when your baby is born, all you need to do is add your baby to your cover within 12 months of the birth. As long as your membership existed at the baby’s date of birth, the child will only have to serve those Waiting Periods not already served by the Principal Member.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "You won’t be charged for hospital accommodation for your baby for the first 10 days of their life unless the baby is admitted to hospital in their own right (e.g. a special care nursery or intensive care). Generally, a newborn isn’t separately admitted to hospital as an inpatient (this is because the baby comes under the mother’s admission).",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "With multiple births, you won’t be charged hospital accommodation for the first baby unless one or more is admitted as an inpatient. You will be charged for hospital accommodation for your second and any subsequent babies so you need to ensure they’re added to your policy from birth.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Remember that your hospital daily charge and/or excess may apply for the mother and any admitted babies, up to the applicable limit. Check your product guide to confirm what limits apply to your cover.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "In some cases, a newborn may need to be admitted to hospital as an inpatient e.g. if they require treatment in a special care nursery or an intensive care unit. Please ",
                contactUsLink,
                " as soon as possible to add your baby to your policy to ensure your newborn will be entitled to receive any benefits under your hospital cover for these services."
            ]
        }),
        title: "Ensure your baby is included in your cover from day one"
    },
    {
        analyticsLabel: "home-birth",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "We’ll pay $1000 for each home birth with a registered Midwife where a Medicare rebate is not payable, after waiting period is served."
        }),
        title: "Want the option of a home birth?"
    }, 
];
/* harmony default export */ var content_items = (items);

// EXTERNAL MODULE: ./src/client/components/needs-product-data-loader/index.ts + 1 modules
var needs_product_data_loader = __webpack_require__(4035);
// EXTERNAL MODULE: ./src/client/components/sections/callout-section/index.tsx
var callout_section = __webpack_require__(54996);
;// CONCATENATED MODULE: ./src/client/pages/pregnancy/components/callout/images/curious.svg
/* harmony default export */ var curious = ({"src":"/_next/static/media/curious.1a123a6e.svg","height":232,"width":260});
;// CONCATENATED MODULE: ./src/client/pages/pregnancy/components/callout/index.tsx






var _URLS = ahm_constants/* default.URLS */.Z.URLS, PRODUCT_LISTING = _URLS.SALES.PRODUCT_LISTING;
var PREGNANCY_COVER = src.CUSTOMER_NEEDS.PREGNANCY_COVER;
var EXTRAS = src.NEEDS_PRODUCT_TYPE_SLUG.EXTRAS;
var PregnancyCallout = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(callout_section/* default */.Z, {
        title: "Missed the 12-month hospital cover waiting period?",
        summary: "You can still join extras cover to claim for things like pre & post-natal services including birthing courses. There may still be waiting periods, but most are less than 12 months.",
        cta: {
            title: "Compare extras",
            to: "".concat(PRODUCT_LISTING, "/").concat(PREGNANCY_COVER, "/").concat(EXTRAS)
        },
        image: {
            alt: "",
            src: curious.src
        },
        withBorder: true
    });
};
/* harmony default export */ var callout = (PregnancyCallout);

// EXTERNAL MODULE: ./src/client/components/sections/products-section/index.tsx + 4 modules
var products_section = __webpack_require__(91331);
// EXTERNAL MODULE: ./src/client/selectors/select-filtered-needs-products-by-customer/index.ts
var select_filtered_needs_products_by_customer = __webpack_require__(2382);
;// CONCATENATED MODULE: ./src/client/pages/pregnancy/index.tsx





















// @ts-expect-error - Automatic, Please fix when editing this file
var onClickOutOfPocket = function(actions) {
    var openIndices = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var newOpenIndices = (0,fp.uniq)((0,fp.concat)(openIndices, outOfPocketSectionIndex));
    actions.accordion.updateAccordionWithId({
        id: accordionId,
        openIndices: newOpenIndices
    });
    (0,ui/* scrollToElement */.kI)(document.getElementById(outOfPocketSectionId));
};
var PregnancyPage = function(param) {
    var actions = param.actions, openIndices = param.openIndices, products = param.products;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var ref = pregnancy_data(function() {
        return onClickOutOfPocket(actions, openIndices);
    }), headerSection = ref.headerSection, productSection = ref.productSection;
    // Only show the $750 excess products
    var productSectionProducts = (0,fp.filter)(function(product) {
        return (0,fp.get)("charges.excess.amount", product) === 750;
    })(products);
    var productSectionProps = {
        compareButtonText: "Compare these options",
        compareButtonToLink: "".concat(ahm_constants/* default.URLS.SALES.PRODUCT_LISTING */.Z.URLS.SALES.PRODUCT_LISTING, "/").concat(src.CUSTOMER_NEEDS.PREGNANCY_COVER, "/").concat(src.NEEDS_PRODUCT_TYPE_SLUG.COMBINED),
        data: productSection,
        products: productSectionProducts,
        withBorder: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head/* default */.Z, {
                titleTemplate: ahm_constants_ui.SHORT_PAGE_TITLE_TEMPLATE,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Private health insurance for pregnancy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Going private provides continuity of care & offers you more choice throughout your pregnancy & birth. Get extra support on your journey. Find out more."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_section, {
                data: headerSection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(products_section/* default */.Z, (0,_object_spread/* default */.Z)({}, productSectionProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(callout, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_section/* default */.Z, {
                accordionId: accordionId,
                // @ts-expect-error - Automatic, Please fix when editing this file
                items: content_items,
                image: null,
                title: "More about our hospital cover for pregnancy and birth",
                withBorder: true
            })
        ]
    });
};
PregnancyPage.defaultProps = {
    openIndices: null
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapStateToProps = function(state, props) {
    return {
        openIndices: (0,fp.get)("accordion.openIndices.".concat(accordionId), state),
        products: (0,select_filtered_needs_products_by_customer/* default */.Z)(state, props)
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            accordion: (0,redux/* bindActionCreators */.DE)(accordion/* default */.Z, dispatch)
        }
    };
};
/* harmony default export */ var pregnancy = ((0,redux/* compose */.qC)(needs_product_data_loader/* default */.Z, (0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps))(PregnancyPage));


;// CONCATENATED MODULE: ./pages/pregnancy/index.page.tsx





// @ts-expect-error - Automatic, Please fix when editing this file
var index_page_PregnancyPage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pregnancy, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, {
        props: props
    }), {
        match: {
            params: {
                needsProductType: "hospital-extras",
                needsType: "pregnancy-cover"
            }
        }
    }));
};
var __N_SSP = true;
/* harmony default export */ var index_page = (index_page_PregnancyPage);


/***/ }),

/***/ 2382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22222);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_get_filtered_products__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5490);
/* harmony import */ var _utils_get_product_ids_from_needs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95890);
/* harmony import */ var _select_customer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34112);
/* harmony import */ var _select_needs_product_type__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82488);
/* harmony import */ var _select_needs_type__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69286);
/* harmony import */ var _select_products__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2664);








var selectFilteredNeedsProductsByCustomer = (0,reselect__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
    _select_customer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
    _select_needs_product_type__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
    _select_needs_type__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    _select_products__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
], function(customer, needsProductType, needsType, products) {
    if (!(0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("hospitalExcess", customer)) {
        return null;
    }
    var productIdsFromNeeds = (0,_utils_get_product_ids_from_needs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        hospitalExcess: null,
        needsProductType: needsProductType,
        needsType: needsType
    });
    return (0,_utils_get_filtered_products__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        customer: customer,
        productIds: productIdsFromNeeds,
        products: products
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (selectFilteredNeedsProductsByCustomer);


/***/ }),

/***/ 5490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _models_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43735);


// Fetches products based on id's and filters them based on scale and state
// @ts-expect-error - Automatic, Please fix when editing this file
var getFilteredProducts = function(param) {
    var customer = param.customer, productIds = param.productIds, products = param.products;
    // Get the products.
    var scale = customer.scale, state = customer.state;
    var resolvedProducts = _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getProducts */ .Z.getProducts(products, productIds);
    // Remove products based on customer state and scale.
    var filteredByStateAndScale = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.filter)(function(product) {
        return _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isAvailableIn */ .Z.isAvailableIn(product, state) && _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isAvailableFor */ .Z.isAvailableFor(product, scale);
    }, resolvedProducts);
    // If we have no products left or we get an error, bail.
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(filteredByStateAndScale) || (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("error", products)) {
        return null;
    }
    return filteredByStateAndScale;
};
/* harmony default export */ __webpack_exports__["Z"] = (getFilteredProducts);


/***/ }),

/***/ 73875:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","headerImageWrapper":"styles_headerImageWrapper__CIRWP","headerImage":"styles_headerImage__SIJTI"};

/***/ }),

/***/ 90569:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","verticalSpacingWrapper":"styles_verticalSpacingWrapper__Q4BRh","horizontalSpacingWrapper":"styles_horizontalSpacingWrapper__i_jOI"};

/***/ }),

/***/ 16567:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 88029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1372,1849,9143,7022,3666,9835,4059,9774,2888,179], function() { return __webpack_exec__(12662); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);